// extracted by mini-css-extract-plugin
export default {"container":"Wallet_container__rEITD"};